<template>
  <div >
    <div v-if="!success" class="pa-2"
    >
      The requested file couldn't not be found.
    </div>

  </div>
</template>

<script>
   import axios from 'axios';

   import data_getters from '../mixins/data_getters'



   export default {
      name: "downloadFile",
      mixins: [data_getters],
      data() {
         return {

            gradedLead: {},
            success: false,

         };
      },

      methods: {
         async download_file(filename){

            let token = await this.$auth.getAxiosHeader();
            let url = this.$baseUrlApi + '/getFile';

            let save_name = filename.split('/');
            save_name = save_name[save_name.length-1];

            axios({
               url: url,
               method: 'post',
               data: {file_key: filename},
               responseType: 'blob', // important
               headers: token['headers'],
            }).then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
            });

         },
      },

      async created(){

         try{
            let tmp  = await this.get_graded_leads({_id: this.$route.params.grade_id});
            console.log('data', tmp);
            this.gradedLead = tmp[0];


            if (this.gradedLead && this.gradedLead.additional_data && this.gradedLead.additional_data.files){
               let file_ix = this.$route.query.file_ix;
               console.log(this.$route.query.file_ix)

               if (file_ix != null){
                  this.file = this.gradedLead.additional_data.files[file_ix];
                  this.download_file(this.file.file_id);
                  this.success = true;
               }


            }

         }catch(e){
            console.log(e);
            this.success = false;
         }



      }
   }
</script>

<style scoped>

</style>